import Icon from '../components/Icon';

const ThumbsUpFilled = Icon(
  'thumbs-up-filled',
  <>
    <path d="M11.83 1.545a.75.75 0 0 0-.917.328L6.848 8.964a.75.75 0 0 0-.1.373V19.5c0 .414.336.75.75.75h9.743a3.75 3.75 0 0 0 3.663-2.947l1.561-7.123a2.75 2.75 0 0 0-2.686-3.339h-4.587V6.1a4.75 4.75 0 0 0-3.065-4.441zM3 9a1.5 1.5 0 0 0-1.5 1.5v8.25a1.5 1.5 0 0 0 1.5 1.5h2.5V9z" />
  </>
);

export default ThumbsUpFilled;
